import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, ref } from 'vue';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import { RouteNames } from '@/enums/routes/RouteNames';
import { ReportTypes } from '@/modules/Statistics/interfaces/ReportTypes';
import { DashboardReportFields } from '@/modules/Statistics/interfaces/DashboardReport';

interface Props {
    data: DashboardReportFields;
    isEdit: boolean;
    isResizable?: boolean;
    shouldShowDownloadBar?: boolean;
    shouldHideDownloadPNGOption?: boolean;
    shouldNavigate?: boolean;
    showPrintExpandOption?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChartHeader',
  props: {
    data: null,
    isEdit: { type: Boolean },
    isResizable: { type: Boolean, default: true },
    shouldShowDownloadBar: { type: Boolean, default: true },
    shouldHideDownloadPNGOption: { type: Boolean, default: false },
    shouldNavigate: { type: Boolean, default: false },
    showPrintExpandOption: { type: Boolean, default: false }
  },
  emits: ["changeChartSize"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'changeChartSize', size: 'S' | 'M' | 'L'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: DashboardReportFields, isEdit: boolean, isResizable: boolean, shouldShowDownloadBar: boolean, shouldHideDownloadPNGOption: boolean, shouldNavigate: boolean, showPrintExpandOption: boolean };





const { proxy } = getCurrentInstance()!;

const routeNames = RouteNames;
const isEditModalVisible = ref(false);
const isDownloadModalVisible = ref(false);
const chartSize = ref<'S' | 'M' | 'L'>(props.data?.size || 'M');
const chartType = ref(props.data?.statisticReport?.data.type);

const downloadOptions = computed(() => {
    const options = [
        {
            title: 'Download PDF',
            icon: 'file-pdf',
            fileType: 'pdf',
        },
        {
            title: 'Download PNG',
            icon: 'file-image',
            fileType: 'png',
        },
        {
            title: 'Download CSV',
            icon: 'file-text',
            fileType: 'csv',
        },
    ];

    if (props.shouldHideDownloadPNGOption) {
        options.splice(1, 1);
    }

    return options;
});

const showPrintToggle = computed(() => {
    return !props.isEdit && props.showPrintExpandOption;
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isSmallChart = computed(() => {
    return (
        chartSize.value === 'S' && (chartType.value === ReportTypes.pieChart || chartType.value === ReportTypes.chart)
    );
});

function updateTogglePrintOption(shouldExpandTableForPrint: boolean) {
    EventBus.$emit(EventBusEvents.setDashboardPrintOption, { reportId: props.data.id, shouldExpandTableForPrint });
}

function openModal() {
    isEditModalVisible.value = true;
}

function openDownloadModal() {
    isDownloadModalVisible.value = true;
}

function deleteChart() {
    EventBus.$emit(EventBusEvents.deleteChart, props.data.id);
}

function showDeleteConfirm() {
    (proxy as any).$confirm({
        title: 'Are you sure delete this report?',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'Cancel',
        onOk() {
            deleteChart();
        },
    });
}

function downloadReport(fileType: string) {
    EventBus.$emit(EventBusEvents.downloadReport, {
        reportId: props.data.id,
        name: props.data?.statisticReport?.name,
        reportData: props.data?.statisticReport?.data,
        fileType,
        reportType: props.data?.statisticReport?.data.type,
    });

    isDownloadModalVisible.value = false;
}

function changeSize() {
    isEditModalVisible.value = false;
    emit('changeChartSize', chartSize.value);
}

return { __sfc: true,props, emit, proxy, routeNames, isEditModalVisible, isDownloadModalVisible, chartSize, chartType, downloadOptions, showPrintToggle, isSmallChart, updateTogglePrintOption, openModal, openDownloadModal, deleteChart, showDeleteConfirm, downloadReport, changeSize }
}

})